commusoftCommon.service('creditNoteData', ['$http','prefix', function($http, prefix) {
    this.selectedReturns = [];
    this.setSelectedReturns = function setSelectedReturns(data){
        this.selectedReturns = data;
    }
    this.getSelectedReturns = function getSelectedReturns(){
        return this.selectedReturns;
    }
}]);